<template>
  <div class="bg-white md__card--holder">
    <div class="card border-0">
      <!-- Card header -->
      <div
        class="card-header bg-navy d-flex align-items-center justify-content-between"
      >
        <!-- Title -->

        <div
          :contenteditable="false"
          @keypress.enter.prevent="onTitleChanged($event)"
          @blur="onTitleChanged($event)"
          class="card-task-title text-white"
          v-html="'<small>' + 'Change Owner for </small>' + editTitle"
          @focus="_onTitleFocusClicked"
        ></div>

        <span class="card-task-title brace">{</span>
      </div>
      <!-- Card Body -->
      <div class="card-body">
        <form class="hideBlockParent" v-if="project.user_owner">
          <UserPicker
            v-model="project.current_owner"
            :multi="false"
            title="Current Owner"
            role="OWNER"
            class="userpicker-sidebar"
            @userSelected="handleSubmit"
            @userRemoved="handleSubmit"
            :showSearch="false"
          />

          <UserPicker
            v-if="project.user_owner && project.current_owner"
            v-model="project.user_owner"
            :multi="false"
            title="New Owner"
            role="OWNER"
            class="userpicker-sidebar"
            @userSelected="handleSubmit"
            @userRemoved="handleSubmit"
            :showSelectedNames="
              project.user_owner.user.id != project.current_owner.user.id
            "
          />

          <!-- <UserPicker v-model="project.user_assigned" :multi="false" title="Assigned To" role="VIEWER"/> -->
          <div class="row mt-4">
            <div :class="{ 'col-md-12': true }">
              <base-button
                type="success"
                class="btn-block"
                @click="handleSubmit"
                >{{ editId ? "Update" : "Create" }}</base-button
              >
            </div>
            <!-- <div class="col-md-6" v-if="editId">
              <base-button
                type="danger"
                class="btn-block"
                @click="_onArchiveClicked"
                >{{ project.is_archieved?"UnArchive":"Archive" }}</base-button
              >
            </div> -->
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import { required, minLength, between, email } from "vuelidate/lib/validators";
import UserPicker from "@/app/components/UserPicker.vue";
import swal from "sweetalert2";

export default {
  name: "ChangeOwner",
  props: ["editId", "data"],
  data() {
    return {
      project: {
        user_owner: {},
        users: []
      },
      editTitle: "Unnamed Project"
    };
  },
  components: {
    UserPicker
  },
  validations: {},

  watch: {
    editId(newVal, oldVal) {
      this.reinitProject(newVal, oldVal);
    },

    data(newVal, oldVal) {
      console.log(oldVal, newVal, "9++++++++++");
      let role = this.roles.filter(r => r.name == "OWNER")[0];
      let owner = { user: this.profile, asset_role: role };

      if (newVal != oldVal) {
        if (newVal) {
          //this.editTitle = "Edit Project"
          this.fetchProject(newVal.id);
        } else {
          this.project = { user_owner: owner, asset_users: [owner] };
          this.editTitle = "Unnamed Project";
        }
      } else {
        this.project = { user_owner: owner, asset_users: [owner] };
        this.editTitle = "Unnamed Project";
      }
    }
  },

  computed: {
    ...mapState("user", ["profile"]),
    ...mapState("common", ["roles"]),

    canEdit() {
      if (this.project.id)
        return (
          this.project &&
          this.project.permission &&
          this.project.permission.edit == 1
        );
      else return true;
    }
  },

  async mounted() {
    console.log("mounted+++++++");
    $('[data-toggle="tooltip"]').tooltipster({
      theme: "tooltipster-borderless"
    });
    await this.fetchRoles();

    if (!this.data) {
      this.editTitle = "Unnamed Project";
      let role = this.roles.filter(r => r.name == "OWNER")[0];
      let owner = { user: this.profile, asset_role: role };
      this.project = { user_owner: owner };
    } else {
      this.editTitle = "Edit Project";
      this.fetchProject(this.data.id);
    }

    this.reinitProject(null, this.editId);
  },

  methods: {
    ...mapActions("project", [
      "createProject",
      "updateProject",
      "fetchSingleProject",
      "updateProjectArchieveStatus"
    ]),
    ...mapActions("common", ["fetchRoles"]),
    ...mapMutations(["setGanttRender"]),

    reinitProject(oldVal, newVal) {
      console.log(oldVal, newVal, "9++++++++++");
      let role = this.roles.filter(r => r.name == "OWNER")[0];
      let owner = { user: this.profile, asset_role: role };

      if (newVal != oldVal) {
        if (newVal) {
          //this.editTitle = "Edit Project"
          this.fetchProject(newVal);
        } else {
          this.project = { user_owner: owner, asset_users: [owner] };
          this.editTitle = "Unnamed Project";
        }
      } else {
        this.project = { user_owner: owner, asset_users: [owner] };
        this.editTitle = "Unnamed Project";
      }
    },

    _onTitleFocusClicked() {
      if (this.editTitle == "Unnamed Project") {
        this.editTitle = "";
      }
    },
    _onTitleFocusClicked() {
      if (this.editTitle == "Unnamed Task") {
        this.editTitle = "";
      }
    },

    async onTitleChanged(event) {
      this.editTitle = event.target.innerHTML;
      let existingTitle = this.project.name;
      if (this.editTitle == "") {
        event.target.innerHTML = "Unnamed Project";
        this.editTitle = "Unnamed Project";
      }

      if (
        this.project &&
        this.project.permission &&
        this.project.permission.edit == 0
      )
        return false;
      if (event.target.innerHTML.length < 5) {
        swal({
          title:
            "Are you sure you want to change the name of this project from " +
            existingTitle +
            " to " +
            event.target.innerHTML +
            "?",
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Yes, change it!",
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            this.project.name = this.editTitle;
            if (existingTitle != this.project.name && this.project.id)
              this.saveTask(false);
            return false;
          } else {
            this.editTitle = existingTitle;
            return false;
          }
        });
        return false;
      } else if (event.target.innerHTML.length > 50) {
        swal({
          title: "Task title is too Long",
          type: "warning",
          // showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "OK",
          buttonsStyling: false
        }).then(result => {});
        return false;
      } else {
        this.project.name = this.editTitle;
        //alert(this.project.id)
        if (existingTitle != this.project.name && this.project.id != null)
          await this.handleSubmit();
        return false;
      }
    },

    async fetchProject(val) {
      try {
        const res = await this.fetchSingleProject(val);
        res.data.current_owner = res.data.user_owner;
        this.project = res.data;
        this.editTitle = this.project.name;
      } catch (e) {
        this.$snack.success("Could not fetch project");
      }
    },

    handleSubmit() {
      if (this.project.name == null || this.project.name == "") {
        this.$snack.success("Project title is required");
        return;
      }

      let body = {
        ...this.project,
        asset_users: [this.project.user_owner]
      };

      if (body.id) {
        this.updateProject(body)
          .then(res => {
            this.setGanttRender();
            this.$snack.success("Project Updated Successfully");
            this.$emit("projectCreated");
            this.editTitle = "Unnamed Project";
          })
          .catch(er => {
            this.$snack.success("Could not create project");
          });
      }
    }
  }
};
</script>

<style scoped>
.card-header {
  background-color: #212529;
  padding: 1rem 1.5rem;
  /* border-bottom: 5px solid #fbdf43; */
  border-radius: 0;
  min-height: 86px;
  max-height: 86px;
}
.card-task-title {
  font-family: "Gotham A", "Gotham B";
  font-size: 2rem;
  line-height: 1;
}

.brace {
  font-family: "Gotham A", "Gotham B";
  color: #fddf43;
}
</style>

<style>
.card-task-title small {
  font-size: 36%;
  font-weight: 400;
  display: block;
  font-family: Open Sans, sans-serif;
  margin-bottom: 0.3rem;
}
.userpicker-sidebar > .row > .col {
  /* background-color: red; */
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}
.userpicker-sidebar > label {
  text-transform: uppercase;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.02em;
}
.userpicker-sidebar .card-body {
  padding-right: 0;
  padding-left: 0;
}
</style>
